export { minuTarnekohad };

const minuTarnekohad = () => {
    if (MODULE_NAME === "minu_tarnekohad") {
        MO.setLat(lat);
        MO.setLng(long);
        MO.setZoom(zoom);
    }
}